"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _Tether = _interopRequireDefault(require("../Tether/Tether"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ToolTip = function ToolTip(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      text = _ref.text,
      openOnTouch = _ref.openOnTouch,
      toolTipAnchorCoord = _ref.toolTipAnchorCoord,
      sourceAnchorCoord = _ref.sourceAnchorCoord,
      props = _objectWithoutPropertiesLoose(_ref, ["disabled", "children", "text", "openOnTouch", "toolTipAnchorCoord", "sourceAnchorCoord"]);

  var timeoutsRef = (0, _react.useRef)({});

  var _useState = (0, _react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      wasTouched = _useState3[0],
      setWasTouched = _useState3[1];

  var showTooltip = function showTooltip() {
    clearTimeout(timeoutsRef.current.showToolTipTimeout);
    clearTimeout(timeoutsRef.current.lagLeaveTimeout);
    clearTimeout(timeoutsRef.current.hideToolTipTimeout);
    setIsOpen(true);
    timeoutsRef.current.showToolTipTimeout = setTimeout(function () {
      return setIsVisible(true);
    }, 50);
  };

  var hideTooltip = function hideTooltip() {
    clearTimeout(timeoutsRef.current.hideToolTipTimeout);
    setIsVisible(false);
    timeoutsRef.current.hideToolTipTimeout = setTimeout(function () {
      return setIsOpen(false);
    }, 300);
  };

  var handleTouchStart = function handleTouchStart() {
    setWasTouched(true);

    if (openOnTouch) {
      (isOpen ? hideTooltip : showTooltip)();
    }
  };

  var handleTouchEnd = function handleTouchEnd() {
    timeoutsRef.current.enableMouseTimeout = setTimeout(function () {
      return setWasTouched(false);
    }, 1000);
  };

  var handleMouseEnter = function handleMouseEnter() {
    if (disabled || wasTouched) return;
    showTooltip();
  };

  var handleMouseLeave = function handleMouseLeave() {
    timeoutsRef.current.lagLeaveTimeout = setTimeout(hideTooltip, 100);
  };

  (0, _react.useEffect)(function () {
    return function () {
      clearTimeout(timeoutsRef.showToolTipTimeout);
      clearTimeout(timeoutsRef.hideToolTipTimeout);
      clearTimeout(timeoutsRef.enableMouseTimeout);
      clearTimeout(timeoutsRef.lagLeaveTimeout);
    };
  }, []);
  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      display: 'inline-block'
    },
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd
  }), (0, _themeUi.jsx)(_Tether["default"], {
    sx: {
      width: 'inherit',
      height: 'inherit'
    },
    shouldUpdatePosition: isOpen || isVisible,
    fitInViewport: true,
    sourceAnchorCoord: sourceAnchorCoord,
    tetherAnchorCoord: toolTipAnchorCoord,
    tetherComponent: (0, _themeUi.jsx)(_react.Fragment, null, isOpen && (0, _themeUi.jsx)("div", {
      sx: {
        color: 'white',
        bg: 'black',
        borderRadius: 'medium',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'scale(1) translateY(0px)' : 'scale(0.95) translateY(4px)',
        transition: "transform 0.25s ease, opacity 0.15s ease",
        maxWidth: 10,
        padding: 2,
        pointerEvents: 'none',
        position: 'relative',
        zIndex: 1,
        textAlign: 'center',
        '&:before': {
          bg: 'inherit',
          content: '""',
          display: 'block',
          height: 1,
          width: 1,
          left: '50%',
          position: 'absolute',
          bottom: 0,
          transform: function transform(theme) {
            return "rotate(45deg) translate(-" + theme.space[1] + "px, " + theme.space[2] + "px)";
          },
          zIndex: -1
        }
      }
    }, (0, _themeUi.jsx)(_Text["default"], {
      variant: "caption",
      sx: {
        display: 'block'
      }
    }, text)))
  }, children));
};

ToolTip.propTypes = {
  children: _propTypes["default"].element.isRequired,
  text: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  openOnTouch: _propTypes["default"].bool,
  toolTipAnchorCoord: _propTypes["default"].shape({
    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),
  sourceAnchorCoord: _propTypes["default"].shape({
    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
};
ToolTip.defaultProps = {
  disabled: false,
  openOnTouch: false,
  sourceAnchorCoord: {
    x: '50%',
    y: '-8'
  },
  toolTipAnchorCoord: {
    x: '50%',
    y: '100%'
  }
};
var _default = ToolTip;
exports["default"] = _default;